var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.languageLoaded)?_c('div',{staticClass:"page"},[_c('Sidebar'),_c('div',{staticClass:"page-main"},[_c('div',{staticClass:"page-main-logo"}),_c('div',{staticClass:"page-main-content"},[_c('router-view')],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }